import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPatientSplitPreview } from '../../actions/patientSplit';
import PatientSplitIcon from './PatientSplitIcon';

// Row previews own their response rather than reading the active viewer's details.
// Fetch only while open, and discard responses after close or a row identity change.
export const PatientSplitRowIcon = ({ fileToken, fetchSplit, fromPage }) => {
  const [visible, setVisible] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => {
    setResult(null);
    if (!visible) return undefined;
    const controller = new AbortController();
    let cancelled = false;
    let refreshing = false;
    const refresh = async () => {
      if (cancelled || refreshing) return;
      refreshing = true;
      try {
        const response = await fetchSplit(fileToken, controller.signal);
        if (!cancelled) setResult({ split: response?.data?.patient_split, failed: !response?.data?.patient_split });
      } catch {
        if (!cancelled) setResult({ failed: true });
      } finally {
        refreshing = false;
      }
    };
    const timer = setInterval(refresh, 5000);
    refresh();
    return () => {
      cancelled = true;
      controller.abort();
      clearInterval(timer);
    };
  }, [visible, fileToken, fetchSplit]);
  return <PatientSplitIcon split={result?.split} failed={result?.failed} surface="inbox" fromPage={fromPage} onVisibleChange={setVisible} />;
};

PatientSplitRowIcon.defaultProps = { fromPage: 'received' };
PatientSplitRowIcon.propTypes = { fromPage: PropTypes.string, fileToken: PropTypes.string.isRequired, fetchSplit: PropTypes.func.isRequired };
export default connect(null, { fetchSplit: getPatientSplitPreview })(PatientSplitRowIcon);
